import { Link, type InertiaLinkProps } from '@inertiajs/react';
import type { ReactNode } from 'react';

type Props = InertiaLinkProps & {
    children: ReactNode;
};

export function TextLink({ children, className = '', ...rest }: Props) {
    return (
        <Link
            {...rest}
            className={
                'cursor-pointer text-foreground underline decoration-neutral-300 underline-offset-4 transition-colors duration-300 ease-out hover:decoration-current dark:decoration-neutral-500 ' +
                className
            }
        >
            {children}
        </Link>
    );
}
